import React from 'react';
import { EstresEnPausaPage } from './pages/EstresEnPausaPage';
export function App() {
  return <EstresEnPausaPage data-id="element-0" />;
}